import { API_URL } from '../config';

export interface AuditLogEntry {
  id: number;
  action: string;
  entityType: string;
  entityId?: number;
  userId: number;
  userEmail: string;
  details: string;
  ipAddress: string;
  userAgent: string;
  timestamp: string;
  oldValues?: string;
  newValues?: string;
  success: boolean;
  errorMessage?: string;
}

class AuditService {
  private getAuthHeaders() {
    const token = localStorage.getItem('token');
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  private buildQuery(params: Record<string, string | number | undefined>): string {
    const query = Object.entries(params)
      .filter(([, value]) => value !== undefined && value !== null && value !== '')
      .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
      .join('&');
    return query ? `?${query}` : '';
  }

  async getSystemAuditLogs(fromDate?: string, toDate?: string): Promise<AuditLogEntry[]> {
    try {
      const query = this.buildQuery({ fromDate, toDate });
      const res = await fetch(`${API_URL}/api/audit/system${query}`, {
        headers: this.getAuthHeaders(),
      });
      if (!res.ok) throw new Error('Error al cargar logs del sistema');
      return await res.json();
    } catch (error) {
      console.error('Error fetching system audit logs:', error);
      return [];
    }
  }

  async getUserAuditLogs(
    userId: number,
    fromDate?: string,
    toDate?: string,
  ): Promise<AuditLogEntry[]> {
    try {
      const query = this.buildQuery({ fromDate, toDate });
      const res = await fetch(`${API_URL}/api/audit/user/${userId}${query}`, {
        headers: this.getAuthHeaders(),
      });
      if (!res.ok) throw new Error('Error al cargar logs del usuario');
      return await res.json();
    } catch (error) {
      console.error('Error fetching user audit logs:', error);
      return [];
    }
  }

  async getEntityAuditLogs(entityType: string, entityId: number): Promise<AuditLogEntry[]> {
    try {
      const res = await fetch(`${API_URL}/api/audit/entity/${entityType}/${entityId}`, {
        headers: this.getAuthHeaders(),
      });
      if (!res.ok) throw new Error('Error al cargar logs de entidad');
      return await res.json();
    } catch (error) {
      console.error('Error fetching entity audit logs:', error);
      return [];
    }
  }
}

const auditService = new AuditService();
export default auditService;
